import React, { lazy, useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Select from "react-select";
import { getCategories } from "../../../MyApi/product/categories";
import {
  showSections,
  storeSections,
  updateSections,
} from "../../../MyApi/section";
import { getCountries } from "../../../MyApi/admin/countries/countries";
import i18next from "i18next";
import LangSelectModal from "../../../Components/UI/langselectmodal";
import { toast } from "react-toastify";
import SkeletonWrapper from "../../../Components/UI/skeletonWrapper";

const StoreSectionModal = ({ isOpen, toggle, refetch, modalMode, modalId }) => {
  const [formData, setFormData] = useState({
    name: "",
    countries: [],
    is_active: 1,
    is_restaurant: false,
    type: "restaurant",
    icon: null,
   sort_order:"",
    categories: [],
  });

  const lang = i18next.language;
  const [selectedLangCode, setSelectedLangCode] = useState("");
  const [error, setError] = useState("");
  const { data: showSectionsData ,isLoading } = useQuery(
    ["showSections", modalId, selectedLangCode],
    () => showSections(modalId, selectedLangCode),
    { enabled: !!modalId && modalMode === "edit" },
  );
  const { data } = useQuery("getCategories", () => getCategories());
  const { data: countryData } = useQuery("getCountry", getCountries);
  const categories = data?.data?.categories || [];
  const countriesOptions = countryData?.data.countries || [];
  const section = showSectionsData?.data?.section || {};

  useEffect(() => {
    if (modalMode === "edit" && showSectionsData) {
      setFormData((prev) => ({
        ...prev,
        name: section?.name,
        countries: section?.countries,
        is_active: section?.is_active ? 1 : 0,
        is_restaurant: section?.is_restaurant ? 1 : 0,
        type: section?.type,
        icon: section?.icon,
       sort_order : section?.sort_order,
        categories: section.categories?.map((cat) => cat.id) || [],
      }));
    }
  }, [showSectionsData]);

  useEffect(() => {
    setSelectedLangCode(lang);
  }, []);
  console.log("formData", formData);
  const mutation = useMutation({
    mutationKey: ["postSections"],
    mutationFn: storeSections,
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
      setFormData({
        name: "",
        is_active: 1,
        is_restaurant: false,
        type: "restaurant",
        icon: null,
        categories: [],
      });
      setError("");
    },
    onError: (error) => {
      setError(error.response.data.message);
    },
  });

  const mutationUpdate = useMutation({
    mutationKey: ["updateSections"],
    mutationFn: (postData) => updateSections(postData, modalId),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
      setFormData({
        name: "",
        is_active: 1,
        is_restaurant: false,
        type: "restaurant",
        icon: null,
        categories: [],
      });
      setError("");
    },
    onError: (error) => {
      setError(error.response.data.message);
    },
  });
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
            ? 1
            : 0
          : type === "file"
            ? files[0]
            : value,
    }));
  };
  const handleSelectedCodeLang = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const handleCategoriesChange = (selectedOptions) => {
    const selectedIds = selectedOptions.map((opt) => opt.value);
    setFormData((prev) => ({
      ...prev,
      categories: selectedIds,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      setError("الاسم مطلوب");
      return;
    }

    const dataToSend = new FormData();
    dataToSend.append("name", formData.name);
    dataToSend.append("is_active", formData.is_active ? 1 : 0);
    dataToSend.append("is_restaurant", formData.is_restaurant ? 1 : 0);
    dataToSend.append("type", formData.type);
    dataToSend.append("sort_order",formData.sort_order)
    formData.countries.forEach((country, index) => {
      dataToSend.append(`countries[${index}]`, country);
    });

    if (formData.icon && formData.icon instanceof File) {
      dataToSend.append("icon", formData.icon);
    }

    formData.categories.forEach((catId) => {
      dataToSend.append("categories[]", catId);
    });

    if (modalMode === "edit") {
      dataToSend.append("lang", selectedLangCode);
      dataToSend.append("_method", "PUT");

      mutationUpdate.mutate(dataToSend);
    } else {
      mutation.mutate(dataToSend);
    }
  };

  const categoryOptions = categories.map((cat) => ({
    value: cat.id,
    label: cat.name,
  }));

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="add">
      <ModalHeader toggle={toggle}>   {modalMode === "edit"?"تعديل قسم جديد":" إضافة قسم جديد " }   </ModalHeader>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <ModalBody>
          {error && <div className="alert alert-danger">{error}</div>}

          {modalMode === "edit" && (
            <LangSelectModal
              selectedLangCode={selectedLangCode}
              handleChange={handleSelectedCodeLang}
            />
          )}


   <FormGroup>
            <Label for="name">ترتيب العرض</Label>
            <SkeletonWrapper isLoading={isLoading}>

            <Input
              id="sort_order"
              name="sort_order"
              value={formData.sort_order}
              onChange={handleChange}
              placeholder=" ترتيب العرض"
              required
              />
              </SkeletonWrapper>
          </FormGroup>
          <FormGroup>
            <Label for="name">الاسم</Label>
                        <SkeletonWrapper isLoading={isLoading}>

            <Input
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="اكتب اسم القسم"
              required
              />
              </SkeletonWrapper>
          </FormGroup>

          <FormGroup>
            <Label for="icon">الأيقونة</Label>
            <SkeletonWrapper isLoading={isLoading}>

            <Input
              id="icon"
              name="icon"
              type="file"
              accept="image/*"
              onChange={handleChange}
              />
              </SkeletonWrapper>
            <small className="text-muted">
              اختر ملف الصورة أو الأيقونة (PNG, JPG, SVG)
            </small>

            {formData.icon && (
              <img
                src={
                  formData.icon instanceof File
                    ? URL.createObjectURL(formData.icon)
                    : formData.icon
                }
                alt=""
                width={40}
                height={40}
              />
            )}
          </FormGroup>
          <div>
            <label htmlFor="">نشط</label>
            <label class="switch">
              <input
                type="checkbox"
                name="is_active"
                onChange={handleChange}
                checked={formData.is_active === 1}
              />
              <span className="slider round"></span>
            </label>
          </div>

          <div>
            <label htmlFor="">مطعم</label>
            <label class="switch">
              <input
                type="checkbox"
                name="is_restaurant"
                checked={formData.is_restaurant === 1}
                onChange={handleChange}
              />
              <span className="slider round"></span>
            </label>
          </div>

          <FormGroup className="mt-3">
            <Label for="type">النوع</Label>
               <SkeletonWrapper isLoading={isLoading}>
                
            
            <Input
              type="select"
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option>اختار</option>
              <option value="delivery_company">شركة شحن</option>
              <option value="restaurant">مطعم</option>
              <option value="pharmacy">صيدلية</option>
              <option value="regular_store">متجر عادي</option>
              {/* <option value="other">أخرى</option> */}
            </Input>   </SkeletonWrapper>
          </FormGroup>
          <FormGroup className="mt-3">
            <Label>الدول</Label>
 <SkeletonWrapper isLoading={isLoading}>

            <Select
              name="countries"
              
              isMulti
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name}
              options={countriesOptions}
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  countries: selected.map((opt) => opt.id),
                }))
              }
              value={countriesOptions.filter((country) =>
                formData.countries.includes(country.id),
              )}
              />
              </SkeletonWrapper>
          </FormGroup>
          <FormGroup className="mt-3">
            <Label>الفئات</Label>
             <SkeletonWrapper isLoading={isLoading}>

            <Select
              isMulti
              options={categoryOptions}
              value={categoryOptions.filter((opt) =>
                formData.categories.includes(opt.value),
              )}
              onChange={handleCategoriesChange}
              placeholder="اختر فئة أو أكثر"
              classNamePrefix="select"
              />
              </SkeletonWrapper>
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <button className="btn btn-white" onClick={toggle}>
            إلغاء
          </button>
          <Button
            color="primary"
            type="submit"
            disabled={mutation.isLoading || mutationUpdate.isLoading}
          >
            {mutation.isLoading || mutationUpdate.isLoading
              ? "جاري الحفظ..."
              : "حفظ"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default StoreSectionModal;
